import App from './App.vue';

export default {
  path: '/CDS_VF_RequestList',
  name: 'CDS_VF_RequestList',
  component: App,
  meta: {
    pageProperty: {
      title: '支援要請一覧',
      controller: 'CDS_CTR_RequestList',
    },
  },
};
